import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';
import {usePortMonitorPause} from 'features/port/model/usePortMonitorMutations';
import {getPortMonitorName} from 'features/port/lib/portMonitorHelper';

interface IPortMonitorPauseModalProps {
    item: IPortMonitorListItem,
    open: boolean,
    handleClose: () => void,
}

const PortMonitorPauseModal: React.FC<IPortMonitorPauseModalProps> = ({item, open, handleClose}) => {
    const {pause, isLoading} = usePortMonitorPause({item, handleClose});

    return (
        <ConfirmModal
            variant="pause"
            open={open}
            handleClose={handleClose}
            header={t`Приостановка монитора порта`}
            title={
                <Trans
                    id="modal.portMonitor.pause.title"
                    message="Вы уверены, что хотите приостановить монитор порта"
                />
            }
            name={getPortMonitorName(item)}
            confirmText={t`Приостановить`}
            onConfirm={pause}
            isLoading={isLoading}
        />
    );
};

export default PortMonitorPauseModal;
